const catagory_types = {
    ADD_TO_CART: 'ADD_TO_CART',
    REMOVE_FROM_CART: "REMOVE_FROM_CART",
    EMPTY_CART: "EMPTY_CART",
    UPDATE_CART: "UPDATE_CART",
}

export default catagory_types;